module.exports = __webpack_public_path__ + "fonts/9e3b39e.woff";